import React from 'react';
import {
  Box,
  Heading,
  Image,
  Text,
  HStack,
  Tag,
  SpaceProps,
  useColorModeValue,
  VStack,
  ButtonGroup,
  Button,
  Stack,
} from '@chakra-ui/react';
import { ProgramInfo } from '../../generated/graphqlModels';
import { Link } from 'react-router-dom';
import ShortInfo from './components/ShortInfo';
import DemoButtonGroup from './DemoButtonGroup';

interface IBlogTags {
  tags: Array<string>;
  marginTop?: SpaceProps['marginTop'];
}

interface BlogAuthorProps {
  name: string;
  url: string;
}

export const BlogAuthor: React.FC<BlogAuthorProps> = (props) => {
  return (
    <HStack display="flex" alignItems="center">
      <Image
        h="auto"
        // boxSize="100px"
        maxH={16}
        objectFit="contain"
        src={props.url}
        alt={props.name}
      />
    </HStack>
  );
};

interface ProgramInfoHeaderProps extends ProgramInfo {
  setModalOpen: (_: boolean) => void;
  donwloadScopeAndSequence: () => void;
}

const ProgramInfoHeader = (props: ProgramInfoHeaderProps) => {
  const {
    name,
    videoUrl,
    image,
    shortDescription,
    tags,
    organization,
    partners,
    scopeAndSequence,
    demo,
    setModalOpen,
    donwloadScopeAndSequence,
  } = props;
  return (
    <VStack
      sx={{
        '.yt-container': {
          position: 'relative',
          overflow: 'hidden',
          width: '100%',
        },
        '.yt-container::after': {
          display: 'block',
          content: '""',
          paddingBottom: '56.25%',
        },
        '.yt-container iframe': {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        },
      }}
      gap={[16]}
    >
      <Stack
        gap={8}
        display="flex"
        flexDirection={{ base: 'column', lg: 'row' }}
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box
          display="flex"
          flex="1"
          position="relative"
          width={{ base: '100%' }}
          overflow="hidden"
        >
          <Box width="100%" zIndex="2">
            <Box>
              {videoUrl ? (
                <div className="yt-container">
                  <iframe
                    style={{ minHeight: '300px' }}
                    width={'100%'}
                    height={'100%'}
                    title="hero-video"
                    frameBorder="0"
                    src={videoUrl}
                    allowFullScreen
                  />
                </div>
              ) : (
                <Image
                  alt={'Hero Image'}
                  fit={'cover'}
                  align={'center'}
                  w={'100%'}
                  h={'100%'}
                  src={image!.url!}
                  borderRadius={4}
                />
              )}
            </Box>
          </Box>
        </Box>
        <Stack
          gap={4}
          display="flex"
          flex="1"
          flexDirection="column"
          justifyContent="center"
        >
          {organization && (
            <BlogAuthor
              name={organization.name}
              url={organization.image!.url}
            />
          )}
          <Heading>{name}</Heading>
          {shortDescription ? (
            <Box
              fontSize="lg"
              dangerouslySetInnerHTML={{ __html: shortDescription }}
            ></Box>
          ) : null}
          <DemoButtonGroup
            demo={demo || undefined}
            scopeAndSequenceUrl={scopeAndSequence?.url}
            setModalOpen={setModalOpen}
            download={donwloadScopeAndSequence}
            programName={name || 'Program Name'}
          />
        </Stack>
      </Stack>
      {partners && partners.length ? (
        <Box padding={[4, 10, 30]} textAlign="center">
          <Text fontSize="3xl" fontWeight="600">
            Developed in collaboration with industry experts
          </Text>
          {partners.map((partner, index) => (
            <Box
              display="inline-block"
              key={partner.id}
              mr={
                partners.length > 1
                  ? partners.length - 1 === index
                    ? 0
                    : 2
                  : 0
              }
            >
              <a href={partner.url} target="_blank">
                <BlogAuthor name={''} url={partner.image!.url} />
              </a>
            </Box>
          ))}
        </Box>
      ) : null}
      <ShortInfo {...props} />
    </VStack>
  );
};

export default ProgramInfoHeader;
